import React from "react";
import CreateUpdateStoreForm from "../CreateUpdateStoreForm/CreateUpdateStoreForm";
import CustomModal from "../../../commons/components/CustomModal/CustomModal";

type Props = {
  store?: Store | null;
  address?: StoreAddress;
  open: boolean;
  setOpenClone: React.Dispatch<React.SetStateAction<boolean>>;
};

const CloneStoreForm: React.FC<Props> = ({ address, store, open, setOpenClone }) => {
  return (
    <>
      <CustomModal open={open} width={1000}>
        <CreateUpdateStoreForm store={store} address={address} isCloning={true} setOpenClone={setOpenClone} />
      </CustomModal>
    </>
  );
};

export default CloneStoreForm;
